import React from 'react';
import { Link } from 'react-router-dom';
import UnifiedAuthPanel from '../components/UnifiedAuthPanel';

const RegisterPage = () => (
  <div className="min-h-screen bg-[#FAFAF7] flex" data-testid="register-page">
    <div className="w-full lg:w-1/2 flex flex-col justify-center px-6 py-12 sm:px-12">
      <div className="mb-8">
        <Link to="/" className="flex items-center gap-3 group" data-testid="auth-logo-link" aria-label="Shopperden home">
          <span aria-hidden="true" className="w-10 h-10 rounded-lg flex items-center justify-center shadow-sm transition-transform duration-200 group-hover:scale-105"
                style={{ background: 'linear-gradient(135deg, #10b981 0%, #0f766e 100%)' }}>
            <svg viewBox="0 0 64 64" className="w-6 h-6" fill="none" stroke="#ffffff" strokeLinejoin="round" strokeLinecap="round">
              <path d="M25 17 Q25 10 32 10 Q39 10 39 17" strokeWidth="2.6" />
              <path d="M14 32 L32 17 L50 32 L50 50 L14 50 Z" strokeWidth="3.6" />
              <path d="M28 50 L28 38 L36 38 L36 50" strokeWidth="3.6" />
            </svg>
          </span>
          <span className="font-['Playfair_Display'] text-xl text-[#0F172A] tracking-wide">
            SHOPPER<span className="text-[#E07A3A]">DEN</span>
          </span>
        </Link>
      </div>
      <UnifiedAuthPanel mode="register" />
    </div>
    <div className="hidden lg:block lg:w-1/2 relative" style={{ background: 'linear-gradient(135deg, #0A0A0C 0%, #1F2937 100%)' }}>
      <div className="absolute inset-0 flex flex-col justify-center px-16 text-white">
        <p className="text-xs tracking-[0.4em] uppercase mb-3" style={{ color: '#D4AF37' }}>Frictionless Sign-up</p>
        <h2 className="font-['Playfair_Display'] text-5xl leading-tight mb-4">One tap to <span className="italic" style={{ color: '#D4AF37' }}>your network.</span></h2>
        <p className="text-white/70 text-base max-w-md">Sign up with Google, WhatsApp <strong>or email</strong> in 30 seconds. No password to forget when you use Google or WhatsApp. Country compliance auto-detected.</p>
      </div>
    </div>
  </div>
);

export default RegisterPage;
